import { CostCentre } from '../../core/models/cost-centre.model';

const ActionTypes = {
  GET_COST_CENTRES: `[COST_CENTRE] Get Cost Centres`,
  GET_COST_CENTRES_SUCCESS: `[COST_CENTRE] Get Cost Centres Success`,
  GET_COST_CENTRES_FAIL: `[COST_CENTRE] Get Cost Centres Fail`,
};

export class GetCostCentresAction {
  static type = ActionTypes.GET_COST_CENTRES;
}

export class GetCostCentresSuccessAction {
  static type = ActionTypes.GET_COST_CENTRES_SUCCESS;

  constructor(public payload: CostCentre[]) {
  }
}

export class GetCostCentresFailAction {
  static type = ActionTypes.GET_COST_CENTRES_FAIL;

  constructor(public payload: any) {
  }
}
